import { getEqlPropsForMetadataCoverage } from '@modules/integrationsV2/utils';
import {
  IntegrationType,
  MetadataDetailsViewFragment,
} from 'generated/graphql';
import useExecuteEQL from 'v2/core/repository/edge-server/eql/useExecuteEQL';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { useGetUser } from 'v2/core/services/user';

interface FetchCoverageForMetadataFieldParams {
  metadataDetails: MetadataDetailsViewFragment;
  metadataIntegrationType: IntegrationType;
  shouldSkip?: boolean;
}

export const useFetchCoverageForMetadataField = ({
  metadataDetails,
  metadataIntegrationType,
  shouldSkip,
}: FetchCoverageForMetadataFieldParams) => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { data, error, status, refetch } = useExecuteEQL({
    input: {
      tenantID,
      eqlProps: getEqlPropsForMetadataCoverage(
        metadataDetails,
        metadataIntegrationType,
      ),
    },
    options: {
      FetchPolicy: 'cache-and-network',
      Skip: shouldSkip,
    },
  });

  const value =
    data?.__typename === 'GetAggregatesResponse' ? data.data[0]?.value ?? 0 : 0;

  return {
    value: parseFloat(value.toFixed(1)),
    error,
    isLoading: data ? false : IsLoading(status),
    refetch,
    status,
  };
};
